import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// --- Dialogs ---
import { ConfirmUnloadModule } from './confirm-unload/confirm-unload.module';

@NgModule({
	declarations: [],
	imports: [
		CommonModule,

		// --- Dialogs ---
		ConfirmUnloadModule,
	],
})
export class DialogsModule {}
